"use strict";

var _slicedToArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderAdapter = void 0;
/**
 * Adapt popular provider methods to they can work across different popular web3 libs (such as web3x and ethers).
 * `sendAsync`, another popular method, is not being adapted here as we didn't find it necessary in our testing.
 * In case you need to adapt it, please create and issue or send a PR
 */

var ProviderAdapter = /*#__PURE__*/function () {
  function ProviderAdapter(provider) {
    var _this = this;

    _classCallCheck(this, ProviderAdapter);

    this.provider = provider;
    this.id = 0;

    this.on = function (event, listener) {
      return _this.provider.on(event, listener);
    };

    this.emit = function (event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return _this.provider.emit(event, args);
    };

    this.removeListener = function (event, listener) {
      return _this.provider.removeListener(event, listener);
    };

    this.request = function (_ref) {
      var method = _ref.method,
          params = _ref.params;
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.isModernProvider() ? this.provider.request({
                  method: method,
                  params: params
                }) : this.send(method, params));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    this.sendAsync = function (args, callback) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.hasSendAsync() ? this.provider.sendAsync(args, callback) : this.send(args, callback));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
  }

  _createClass(ProviderAdapter, [{
    key: "send",
    value: function send(methodOrArgs, paramsOrCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var method, params, callback, hasCallback, args, _yield$this$provider$, _yield$this$provider$2, err, result, returnValue, _ref2, _ref3, _err, value;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                hasCallback = typeof paramsOrCallback === 'function';

                if (hasCallback) {
                  args = methodOrArgs; // if sendParams is a function, the first argument has all the other data

                  params = args.params || [];
                  method = args.method;
                  callback = paramsOrCallback;
                } else {
                  method = methodOrArgs;
                  params = paramsOrCallback || [];

                  callback = function callback(err, value) {
                    if (err) {
                      throw err;
                    }

                    return value;
                  };
                }

                if (!this.isModernProvider()) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 5;
                return this.provider.request({
                  method: method,
                  params: params
                }).then(function (result) {
                  return [null, result];
                }).catch(function (error) {
                  return [error, undefined];
                });

              case 5:
                _yield$this$provider$ = _context3.sent;
                _yield$this$provider$2 = _slicedToArray(_yield$this$provider$, 2);
                err = _yield$this$provider$2[0];
                result = _yield$this$provider$2[1];
                returnValue = hasCallback ? {
                  id: '',
                  jsonrpc: '2.0',
                  result: result
                } : result;
                return _context3.abrupt("return", callback(err, returnValue));

              case 13:
                this.patchOldMobile();

                if (!hasCallback) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 17;
                return new Promise(function (resolve) {
                  return _this2.provider.send(methodOrArgs, function (err, value) {
                    resolve([err, value]);
                  });
                });

              case 17:
                _context3.t0 = _context3.sent;
                _context3.next = 23;
                break;

              case 20:
                _context3.next = 22;
                return new Promise(function (resolve) {
                  return _this2.provider.send({
                    jsonrpc: '2.0',
                    id: ++_this2.id,
                    method: method,
                    params: params
                  }, function (err, value) {
                    resolve([value && value.hasOwnProperty('error') ? value.error : err, value && value.hasOwnProperty('result') ? value.result : value]);
                  });
                });

              case 22:
                _context3.t0 = _context3.sent;

              case 23:
                _ref2 = _context3.t0;
                _ref3 = _slicedToArray(_ref2, 2);
                _err = _ref3[0];
                value = _ref3[1];
                return _context3.abrupt("return", callback(_err, value));

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "isModernProvider",
    value: function isModernProvider() {
      return typeof this.provider['request'] === 'function';
    }
  }, {
    key: "hasSendAsync",
    value: function hasSendAsync() {
      return typeof this.provider['sendAsync'] === 'function';
    }
  }, {
    key: "patchOldMobile",
    value: function patchOldMobile() {
      // Patch for old providers and mobile providers which do not use promises at send as sendAsync
      if (this.provider && !this.provider.isDapper && !this.provider.isFortmatic && !this.provider.isMetamask && this.hasSendAsync() && this.provider.send !== this.provider.sendAsync) {
        // send has to be replaced by sendAsync for old providers
        this.provider.send = this.provider.sendAsync;
      }
    }
  }], [{
    key: "adapt",
    value: function adapt(provider) {
      var providerAdapter = new ProviderAdapter(provider);
      return Object.assign(Object.assign({}, provider), {
        on: providerAdapter.on,
        emit: providerAdapter.emit,
        removeListener: providerAdapter.removeListener,
        request: providerAdapter.request,
        sendAsync: providerAdapter.sendAsync,
        send: providerAdapter.send.bind(providerAdapter)
      });
    }
  }]);

  return ProviderAdapter;
}();

exports.ProviderAdapter = ProviderAdapter;